import axios from 'axios';
import WapiContract from '../../models/contract/WapiContract.js';
import WapiReanalysisSettings from '../../models/contract/WapiReanalysisSettings.js';
import { API_EDIT_CONTRACT, API_CREATE_CONTRACT, API_GET_CONTRACTS, API_GET_CONTRACT_INFO } from '../../constants'

export default {
  state: {
    contracts: [],
    contract: null,
    userId: ''
  },
  mutations: {
    SET_CONTRACTS: (state, payload) => {
      state.contracts = payload;
    },
    SET_USER_ID: (state, payload) => {
      state.userId = payload;
    },
    SET_CONTRACT: (state, payload) => {
      if (state.userId !== payload.user_id) {
        return;
      }

      const index = state.contracts.findIndex(x => x.id === payload.id);
      if (index !== -1) {
        state.contracts[index] = payload;
      }
      else {
        state.contracts.push(payload);
      }
    },
  },
  actions: {
    FETCH_CONTRACTS: async (context, payload) => {
      context.commit('SET_USER_ID', payload);
      let contractsResponse = await axios.get(`${API_GET_CONTRACTS}/${payload}`);
      const contracts = contractsResponse.data.result.data;
      contracts.forEach((contract) => {
        if (!contract.reanalysis_settings) {
          contract.reanalysis_settings = new WapiReanalysisSettings();
        }
      })
      context.commit('SET_CONTRACTS', contracts);
    },
    FETCH_CONTRACT_INFO: async (context) => {
      try {
        let contractsResponse = await axios.get(`${API_GET_CONTRACT_INFO}`);
        const contract = contractsResponse.data.result.data[0];
        return contract;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    CREATE_CONTRACT: async (context, payload) => {
      try {
        let userResponse = await axios.post(API_CREATE_CONTRACT, payload);
        context.commit('SET_CONTRACT', userResponse.data.result);
        context.commit('PUSH_SUCCESS', 'Контракт успешно создан');
        return userResponse.data.result;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    UPDATE_CONTRACT: async (context, payload) => {
      try {
        await axios.put(API_EDIT_CONTRACT, payload);
        context.commit('SET_CONTRACT', payload);
        context.commit('PUSH_SUCCESS', 'Контракт успешно изменен');
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
  },
  getters: {
    EMPTY_CONTRACT: () => {
      return new WapiContract();
    },
    CONTRACTS: state => {
      return state.contracts;
    },
    CONTRACT_BY_ID(state) {
      return contractId => {
        return state.contracts.find(contract => contract.id === contractId)
      }
    },
    CONTRACT_BY_USERID: state => {
      return userId => {
        return state.contracts.find(contract => contract.user_id === userId);
      }
    }
  }
}